import React, { useCallback, useEffect, useState } from 'react'
import styled from 'styled-components'
import LobbyEntry from '../components/LobbyEntry'
import LobbyOverlay from '../components/LobbyOverlay'
import PageWithBg from '../components/PageWithBg'
import config from '../config'
import Amplitude from '../utils/amplitudeHelper'
import LoadIcon from '../components/LoadIcon'
import GameStand from '../images/gamification/gameStand.gif'
import GameModal from '../components/Gamification/GameModal'
import { CPDBanner } from 'src/components/CPDBanner'
import { useObject } from 'react-firebase-hooks/database'
import { getLiveCheckInSessionDb } from 'src/firebaseConfig'

const PageWrapper = styled.div`
  .trailer {
    opacity: 0;
    background-color: black;
    position: absolute;
    top: 99%;
    left: 99%;
    right: 0%;
    bottom: 0%;
  }
  #game-stand {
    position: absolute;
    left: 11%;
    bottom: 9%;
    cursor: pointer;
  }
  #current-user {
    pointer-events: none;
    position: absolute;
    right: 5px;
    bottom: 5px;
    font-size: 10px;
    color: gray;
  }
  #banner {
    position: absolute;
    cursor: pointer;
    top: 41.3%;
    bottom: 35.1%;
    left: 47.3%;
    right: 45.1%;
  }
`

export default function LobbyPage({ currentUser }) {
  const [overlayTitle, setOverlayTitle] = useState('Select hall to enter:')
  const [overlay, setOverlay] = useState(null)
  const [isLoading, setIsLoading] = useState(true)
  const [showModal, setShowModal] = useState(false)
  const [snapshot, snapshotLoading, snapshotError] = useObject(getLiveCheckInSessionDb(5))

  const showEntryOverlay = (destinations) => {
    setOverlay(destinations)
  }

  const hideOverlay = () => setOverlay(null)

  const escFunction = useCallback((event) => {
    if (event.keyCode === 27) {
      hideOverlay()
    }
  }, [])

  const showHelpDesk = () => {
    const cpt = window.chaport
    cpt.on('ready', function () {
      cpt.setVisitorData({
        name: currentUser.fullName,
        email: currentUser.email,
      })
      cpt.open()
    })
    cpt.on('collapsed', function () {
      cpt.close()
    })
    Amplitude.clickHelpDesk()
  }

  useEffect(() => {
    document.title = `${config.eventName} | Lobby`
  }, [])

  useEffect(() => {
    Amplitude.visit('Lobby')
  }, [currentUser.id])

  useEffect(() => {
    document.addEventListener('keydown', escFunction, false)

    return () => {
      document.removeEventListener('keydown', escFunction, false)
    }
  }, [escFunction])

  const toggleModal = () => {
    setShowModal(!showModal)
  }

  return (
    <>
      {isLoading && <LoadIcon />}
      <PageWrapper style={{ opacity: isLoading ? 0 : 1 }}>
        <PageWithBg bgImg={config.assets.lobby.landscape}>
          <LobbyOverlay overlayTitle={overlayTitle} overlay={overlay} hideOverlay={hideOverlay} />
          {config.lobbyEntries.map((entry) => {
            return <LobbyEntry showHelpDesk={showHelpDesk} key={entry.id} setOverlayTitle={setOverlayTitle} showEntryOverlay={showEntryOverlay} {...entry} />
          })}
          <img id="game-stand" width="130px" src={GameStand} alt="game stand" onClick={toggleModal} />
          <div className="trailer">
            <iframe
              width="100%"
              height="100%"
              title="Lobby Vimeo"
              src="https://player.vimeo.com/video/505055532?autoplay=0&muted=1"
              allow="autoplay; fullscreen"
              allowFullScreen
              frameBorder="0"
              onLoad={() => {
                setIsLoading(false)
              }}
            />
          </div>
          <CPDBanner snapshot={snapshot} snapshotLoading={snapshotLoading} snapshotError={snapshotError}/>
          <div id="current-user">Logged in as {currentUser.email}</div>
        </PageWithBg>
        {showModal && <GameModal showModal={showModal} hideModal={toggleModal} currentUser={currentUser} />}
      </PageWrapper>
    </>
  )
}
